module.exports = __webpack_public_path__ + "static/media/greenRev_desktop.94c17ecf.jpg";